// extracted by mini-css-extract-plugin
export default {"mainContainer":"DesktopStyles_mainContainer__MVmmg"};